<script>
import { viewport } from "@/mixins/viewport";
import IconClose from "@/components/ui/IconClose";
import IconMenu from "@/components/ui/IconMenu";

export default {
  name: "MenuMain",
  mixins: [viewport],
  components: {
    IconClose,
    IconMenu
  },
  computed: {
    navigation() {
      return this.$store.state.navigation;
    },
    classes() {
      return [
        "main-navigation",
        {
          sticky: this.navigation.sticky,
          open: this.navigation.open
        }
      ];
    }
  },
  methods: {
    toggle() {
      this.$store.commit("updateNavigation", { open: !this.navigation.open });
      if (this.viewport.mobile) {
        const scrollPos = window.scrollY;

        if (this.navigation.open) {
          document.body.classList.add("lock");
          document.body.style.position = "fixed";
          document.body.style.top = `-${scrollPos}px`;
        } else {
          const top = document.body.style.top;
          document.body.classList.remove("lock");
          document.body.style.position = "";
          document.body.style.top = "";
          window.scrollTo(0, parseInt(top || "0") * -1);
        }
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
@import "MenuMain"
@import "MenuLinks"
@import "MenuToggle"
</style>
